import React, { Component } from 'react'
import withRouter from '../lib/withRouter';
import { connect } from 'react-redux';
import Authentication from '../../session'
import Service from '../services'
import { BasicLazyParams } from '../../utile';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { getBranchesLatest } from '../../store/actions';
import BranchToClassDDRow from '../BaseDropdownComponents/BranchToClassDDRow';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import LoadingComponent from '../loadingComponent';
import { baseUrlAdmin } from '../../store/apiConstants';
import { Button } from 'primereact/button';
import * as XLSX from 'xlsx';
import moment from 'moment';

const months = [
    { value: "January", label: 'January' },
    { value: "February", label: 'February' },
    { value: "March", label: 'March' },
    { value: "April", label: 'April' },
    { value: "May", label: 'May' },
    { value: "June", label: 'June' },
    { value: "July", label: 'July' },
    { value: "August", label: 'August' },
    { value: "September", label: 'September' },
    { value: "October", label: 'October' },
    { value: "November", label: 'November' },
    { value: "December", label: 'December' }
]

class FunnelReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredUsers: [],
            lazyParams: BasicLazyParams,
            totalRecords: 0,
            globalFilter: null,
            selectedMonths: [],
            selectedWeeks: [],
            weeksOptions: [],
            loading: false,
            fullReportData: [],
            filteredReportData: [],
            reportData: [],
            selectedBranch: [],
            selectedBoard: [],
            selectedGrade: [],
            isLoading: false,
        };
        this.service = new Service();
    }

    async componentDidMount() {
        this.props.getBranchesLatest(true);
        await this.fetchReportData();
    }

    onPage = (event) => {
        this.setState((prevState) => ({
            lazyParams: {
                ...prevState.lazyParams,
                ...event
            }
        }), this.updatePaginatedData);
    };

    updatePaginatedData = () => {
        const { lazyParams, filteredReportData } = this.state;
        const startIndex = lazyParams.first;
        const endIndex = startIndex + lazyParams.rows;
        const paginatedData = filteredReportData.slice(startIndex, endIndex);
        this.setState({ reportData: paginatedData });
    };

    filterReportData = () => {
        const { fullReportData, selectedBranch, selectedBoard, selectedGrade, selectedMonths, selectedWeeks } = this.state;
        let filteredData = [...fullReportData];

        if (selectedMonths?.length > 0) {
            filteredData = filteredData.filter(item => selectedMonths.includes(item.month));
        }

        let branch = selectedBranch?.map(item => item).flat();
        let board = selectedBoard?.map(item => item).flat();
        let grade = selectedGrade?.map(item => item).flat();

        if (branch?.length > 0) {
            filteredData = filteredData.filter(item => branch.includes(item.branchId));
        }
        if (board?.length > 0) {
            filteredData = filteredData.filter(item => board.includes(item.boardId));
        }
        if (grade?.length > 0) {
            filteredData = filteredData.filter(item => grade.includes(item.gradeId));
        }

        // Handle weekly data when weeks are selected
        if (selectedMonths?.length === 1 && selectedWeeks?.length > 0) {
            let weeklyData = [];
            filteredData.forEach(monthData => {
                const selectedWeekData = monthData.weekly.filter(week =>
                    selectedWeeks.includes(week.weekNumber)
                );

                selectedWeekData.forEach(weekData => {
                    weeklyData.push({
                        ...monthData,
                        week: `Week ${weekData.weekNumber}`,
                        enquiries: weekData.enquiries,
                        applications: weekData.applications,
                        registrations: weekData.registrations,
                        exams: weekData.exams,
                        enrollments: weekData.enrollments
                    });
                });
            });
            filteredData = weeklyData;
        }

        this.setState({
            filteredReportData: filteredData,
            totalRecords: filteredData.length
        }, this.updatePaginatedData);
    };

    fetchReportData = async () => {
        this.setState({ isLoading: true });
        try {
            const response = await this.service.post(`${baseUrlAdmin}/admissionReports/funnelReport`, {
                academicYear: localStorage.getItem('userAcademicYear'),
                months: this.state.selectedMonths,
                branchId: this.state.selectedBranch,
                boardId: this.state.selectedBoard,
                gradeId: this.state.selectedGrade
            }, true);

            if (response?.res?.status) {
                this.setState({
                    fullReportData: response?.res?.data,
                    filteredReportData: response?.res?.data,
                    totalRecords: response?.res?.data.length
                }, this.updatePaginatedData);
            }
        } catch (error) {
            console.error('Error fetching report data:', error);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    setDropdownValues = (values) => {
        this.setState((prevState) => ({
            selectedBranch: values.branchId,
            selectedBoard: values.boardId,
            selectedGrade: values.classId
        }), this.filterReportData)
    };

    getWeeksInMonth = (month) => {
        const year = new Date().getFullYear();
        const firstDay = new Date(year, months.findIndex(m => m.value === month), 1);
        const lastDay = new Date(year, months.findIndex(m => m.value === month) + 1, 0);

        const weeks = [];
        let weekCounter = 1;

        for (let d = firstDay; d <= lastDay; d.setDate(d.getDate() + 7)) {
            const weekStart = new Date(d);
            let weekEnd = new Date(d);
            weekEnd.setDate(weekEnd.getDate() + 6);

            // Ensure weekEnd doesn't go beyond the current month
            if (weekEnd > lastDay) {
                weekEnd = new Date(lastDay);
            }

            // Format dates
            const startDate = weekStart.getDate();
            const endDate = weekEnd.getDate();

            weeks.push({
                value: weekCounter,
                label: `Week ${weekCounter} (${startDate}-${endDate})`
            });
            weekCounter++;
        }
        return weeks;
    };

    onChangeMonths = (e) => {
        const selectedMonths = e.value;
        let weeksOptions = [];

        if (selectedMonths.length === 1) {
            weeksOptions = this.getWeeksInMonth(selectedMonths[0]);
        }

        this.setState({
            selectedMonths,
            weeksOptions,
            selectedWeeks: []
        }, this.filterReportData);
    };

    onChangeWeeks = (e) => {
        this.setState({
            selectedWeeks: e.value
        }, this.filterReportData);
    };

    exportToExcel = () => {
        const { filteredReportData, selectedMonths, selectedWeeks } = this.state;

        // Format data for export
        const exportData = filteredReportData.map(item => {
            let rowData = {
                'Branch': item.branchName,
                'Board': item.boardName,
                'Grade': item.gradeName,
                'Month': item.month,
            };

            // Add Week column if weekly data is displayed
            if (selectedMonths?.length === 1 && selectedWeeks?.length > 0 && item.week) {
                rowData['Week'] = item.week;
            }

            // Add stage columns
            rowData['Enquiry'] = item.enquiries;
            rowData['Application'] = item.applications;
            rowData['Exam'] = item.exams;
            rowData['Registration'] = item.registrations;
            rowData['Enrollment'] = item.enrollments;

            return rowData;
        });

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Funnel Report");

        // Generate and download file
        XLSX.writeFile(workbook, `Funnel_Report_${moment().format('DD-MM-YYYY')}.xlsx`);
    };

    render() {
        const containerStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: window.innerWidth > 1090 ? "50px 0px 0px 95px" : "50px 0px 0px 15px",
            overflow: 'auto',
            transition: 'padding 0.3s',
            paddingBottom: '30px',
        };
        return (
            <>
                <div style={containerStyle} className=' m-2'>
                    <div className="card filters-card mt-1 pt-0">
                        <BranchToClassDDRow
                            setValues={this.setDropdownValues}
                            showTooltip={false}
                            tooltip={null}
                            tooltipOptions={{ disabled: true }}
                        />
                        <div className='flex '>
                            <div className="col-4 my-2">
                                <ClassetMultiSelect
                                    required={true}
                                    label={'Months'}
                                    placeholder={'Select Month'}
                                    options={months}
                                    value={this.state.selectedMonths}
                                    onChange={this.onChangeMonths}
                                    optionLabel="label"
                                    optionValue="value"
                                    multiple={true}
                                />
                            </div>
                            {this.state.selectedMonths.length === 1 && (
                                <div className="col-4 my-2">
                                    <ClassetMultiSelect
                                        label={'Weeks'}
                                        placeholder={'Select Weeks'}
                                        options={this.state.weeksOptions}
                                        value={this.state.selectedWeeks}
                                        onChange={this.onChangeWeeks}
                                        optionLabel="label"
                                        optionValue="value"
                                        multiple={true}
                                    />
                                </div>
                            )}
                            <div className="col-3 mt-5 flex justify-content-end align-items-center gap-5 ms-auto" style={{ maxWidth: 'fit-content' }}>
                                <Button
                                    label="Download Report"
                                    onClick={this.exportToExcel}
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#F4F5F6", color: "#000" }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="datatable-report-demo mx-2">
                        <DataTable
                            value={this.state.reportData}
                            responsiveLayout="scroll"
                            dataKey="id"
                            paginator
                            lazy
                            onPage={this.onPage}
                            resizableColumns
                            first={this.state.lazyParams.first}
                            last={this.state.totalRecords}
                            rows={this.state.lazyParams.rows}
                            totalRecords={this.state.totalRecords}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                            rowClassName={() => 'table-row-style'}
                        >
                            <Column field="branchName" header="Branch" />
                            <Column field="boardName" header="Board" />
                            <Column field="gradeName" header="Grade" />
                            <Column field="month" header="Month" />
                            {this.state.selectedMonths?.length === 1 && this.state.selectedWeeks?.length > 0 && (
                                <Column field="week" header="Week" />
                            )}
                            <Column field="enquiries" header="Enquiry" />
                            <Column field="applications" header="Application" />
                            <Column field="exams" header="Exam" />
                            <Column field="registrations" header="Registration" />
                            <Column field="enrollments" header="Enrollment" />
                        </DataTable>
                    </div>
                    {this.state.isLoading && <LoadingComponent />}
                </div>
            </>
        )
    }
}

const mapStatesToProps = (state) => ({
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data?.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._idF
});
export default connect(mapStatesToProps, { getBranchesLatest })(Authentication(withRouter(FunnelReport)));